<template>
  <div style="width: 21cm; height: 29cm" class="card">
    <div class="card-header">
      <strong>Print Preview</strong>
      <div class="card-header-actions">
        <CLink class="card-header-action btn-minimize">
          <c-button
            color="success"
            @click="confirmApprove = true"
            v-c-tooltip.hover.click="'Approve'"
            class="btn-action"
          >
            <i class="cil-check"></i>
          </c-button>
          <c-button
            color="info"
            @click="doPrint"
            class="btn-action"
            v-c-tooltip.hover.click="'Cetak'"
          >
            <i class="cil-print"></i>
          </c-button>
          <c-button
            color="danger"
            @click="doClose"
            class="btn-action"
            v-c-tooltip.hover.click="'Close'"
          >
            <i class="cil-x"></i>
          </c-button>
        </CLink>
      </div>
    </div>
    <router-view />
    <CModal title="Approve Confirmation" size="sm" color="info" :show.sync="confirmApprove">
      Cetak nota ?
      <template #footer>
        <CButton @click="confirmApprove = false" color="danger">Tidak</CButton>
        <CButton @click="doApprove" color="success">Ya</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
export default {
  name: "Preview",
  data() {
    return {
      confirmApprove: false,
      query: {},
      params: {}
    };
  },
  created() {
    this.params = this.$route.params;
    this.query = this.$route.query;
  },
  methods: {
    doPrint() {
      console.log(this.query)
      window.open("#" + this.query.printurl + "/" + this.params.id, "_blank");
    },
    doClose() {
      this.$router.push({ path: this.query.rollback });
    },
    doApprove() {
      HTTPAUTH.put("/api/v1/sale/" + this.params.id)
        .then(res => {
          this.$toasted.success("Berhasil").goAway(3000);
          this.$router.push({ path: this.query.rollback });
        })
        .catch(eres => {
          this.$toasted.error(eres.response.data.user_message).goAway(3000);
        });
      this.confirmApprove = false;
    }
  }
};
</script>